module.exports = __webpack_public_path__ + "img/topicHiTech.9cf3abbc.webp";